"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecodableApiError = void 0;
class DecodableApiError extends Error {
    constructor(status, statusText, body, requestId = "") {
        super(`API response not OK:\n${status} — ${statusText}`);
        this.isDecodableApiError = true;
        this.status = status;
        this.statusText = statusText;
        this.requestId = requestId;
        // todo: This maintains legacy behavior, but maybe just use a `body` field instead?
        if (body && typeof body === "object") {
            Object.assign(this, body);
        }
    }
    static fromResponse(response) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            let body = null;
            if (((_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("Content-Type")) == "application/json") {
                try {
                    body = yield response.json();
                }
                catch (_c) {
                    // ignored - parsing the error details is best effort
                }
            }
            const requestId = (_b = response.headers) === null || _b === void 0 ? void 0 : _b.get("x-request-id");
            return new DecodableApiError(response.status, response.statusText, body, requestId);
        });
    }
    toString() {
        if (typeof this.message === "string") {
            return this.message;
        }
        return super.toString();
    }
}
exports.DecodableApiError = DecodableApiError;
